import type { PropsWithChildren } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  isUncollapsed: boolean
  onChange: (isActive: boolean) => void
}

const CollapsedToggle = ({ children, isUncollapsed, onChange }: PropsWithChildren<Props>) => {
  const toggleIsActive = () => {
    onChange(!isUncollapsed)
  }

  return (
    <Box
      onClick={toggleIsActive}
      flexDirection="row"
      paddingLeft="s8"
      paddingRight="s2"
      height="s24"
      alignItems="center"
      justifyContent="center"
      background={!isUncollapsed ? 'grey400' : 'grey000White'}
      border={{
        all: {
          color: 'grey400',
          width: 's2',
          style: 'solid',
        },
      }}
      cursor="pointer"
      borderRadius={{
        all: 'abs016',
      }}
    >
      <Box paddingRight="s6">
        <Text.Normal color="grey800" weight="bold" size="100">
          {children}
        </Text.Normal>
      </Box>
      <Icon.Small
        icon={!isUncollapsed ? 'add' : 'remove'}
        color={!isUncollapsed ? 'grey400' : 'grey600'}
        encircled={!isUncollapsed ? 'grey600' : 'grey400'}
      />
    </Box>
  )
}

export default CollapsedToggle
